var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.mainStyle,
      style: { "background-image": "url(" + _vm.backgroundContent + ")" }
    },
    [
      _c(
        "div",
        { class: _vm.$style.mainContent },
        [_c("Logo"), _vm._v(" "), _vm._t("default"), _vm._v(" "), _vm._m(0)],
        2
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [
      _vm._v("The kiosk "),
      _c("span", [_vm._v("does not")]),
      _vm._v(" accept cash")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/layouts/KioskSplashLayout.vue?vue&type=template&id=418aa36a&
// module id = null
// module chunks = 